import React from 'react'
import Image from './image';
import img from '../assets/images/subcat.png'

const SubCollection = ({ data }) => {
  return (
    <div className='Collection__sub'>
      <div className='Collection__sub__image'>
        <Image source={data.image || img} imgClass='Collection__sub__image--wrap' />
      </div>
      <div className='Collection__sub__button'>{data.title}</div>
    </div>
  )
}

export default SubCollection